export const isBlank = str => /^\s+$/.test(str);

export const isNotBlank = str => !isBlank(str);
